"use client";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import styles from "./styles.module.scss";

import StyledIcon from "@generic-components/StyledIcon";
import { APIURL } from "@app/config/apiUrl";
import axiosInstance from "public/middleware/axios-wrapper";
import { COOKIE_NAME, DESTINATION, OTP_INSTANCE } from "@app/components/config";
import { useDispatch, useSelector } from "react-redux";
import {
  getRegistrationDetails,
  setRegistrationDetails,
} from "@app/lib/features/register/registerSlice";
import { encryptData } from "@app/utils/encrypt";
import { setCookie } from "@app/utils/cookie";
import {
  getUserDetail,
  setRole,
  setUserDetails,
} from "@app/lib/features/login/loginSlice";
import {
  capitalizeWords,
  executeCaptcha,
  pushGaEvents,
} from "@app/utils/common";

interface GetOTPProps {
  isEmail: boolean;
  value?: string;
  verification: boolean;
  onSubmit: any;
  onBack: any;
  isLogin?: boolean;
  payload?: any;
  isResetFlow?: any;
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  onClose?: any;
  isFrom?: string;
  userEmailData?: any;
  saveContactDetails?: (userData: any) => void;
}

const GetOTPComponent = ({
  isEmail,
  value,
  verification,
  onSubmit,
  onBack,
  isLogin,
  payload = {},
  isResetFlow = false,
  visible = false,
  setVisible = () => {},
  onClose,
  isFrom = "",
  userEmailData = {},
  saveContactDetails = () => {},
}: GetOTPProps) => {
  const dispatch = useDispatch();
  const registrationDetails = useSelector(getRegistrationDetails);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [wrongOTP, setWrongOTP] = useState(false);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [pinId, setPinId] = useState(payload?.pinId);
  const [showModal, setShowModal] = useState(false);
  const { userDetails } = useSelector(getUserDetail);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const MAX_OTP_ATTEMPTS = 4;
  const [otpAttempts, setOtpAttempts] = useState<{ [key: string]: number }>({});

  const sendOtp = async () => {
    try {
      const token: any = await executeCaptcha();
      if (token) {
        const sendOtpUrl = `/${APIURL.AUTH}/${APIURL.OTP}/${APIURL.SEND}`;

        const sendOtpPayloadMobile = {
          destination: DESTINATION.MOBILE,
          mobile: payload.mobile || registrationDetails?.mobile,
          instance: payload?.instance || OTP_INSTANCE.VERIFICATION,
          fullName: registrationDetails.fullName,
        };

        const sendOtpPayloadEmail = {
          destination: DESTINATION.EMAIL,
          email: payload.email || registrationDetails?.email,
          instance: payload?.instance || OTP_INSTANCE.VERIFICATION,
          fullName: registrationDetails.fullName,
        };

        const res = await axiosInstance.post(
          sendOtpUrl,
          isEmail ? sendOtpPayloadEmail : sendOtpPayloadMobile,
          {
            headers: {
              captchatoken: token,
            },
          }
        );

        if (res.success && !isEmail) {
          setPinId(res?.data?.pinId);
        }
      }
    } catch (err) {
      console.error("Error in sending OTP: ", err);
    }
  };

  useEffect(() => {
    if (isFrom !== "property-details-update") {
      sendOtp();
    }
    setOtp(["", "", "", ""]);
  }, [isEmail]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    e.preventDefault();
    setWrongOTP(false);
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setError("");
      if (value) {
        if (index < 3) {
          (
            document.getElementById(`otp-${index + 1}`) as HTMLInputElement
          ).focus();
        }
      } else {
        if (index > 0) {
          (
            document.getElementById(`otp-${index - 1}`) as HTMLInputElement
          ).focus();
        }
      }
    } else if (index > 0) {
      (document.getElementById(`otp-${index - 1}`) as HTMLInputElement).focus();
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    // console.log(payload, "PAyload submit");

    e.preventDefault();
    if (otp.join("").length === 4) {
      try {
        if (payload.instance === OTP_INSTANCE.FORGOT || payload.shouldVerify) {
          const sendOtpUrl = `/${APIURL.AUTH}/${APIURL.OTP}/${APIURL.VERIFY}`;
          const sendOtpPayload: any = {
            otp: otp.join(""),
            instance: payload.instance,
          };
          if (isEmail) {
            sendOtpPayload.email = payload.email;
            sendOtpPayload.destination = "email";
          } else {
            sendOtpPayload.mobile = payload.mobile;
            sendOtpPayload.destination = "mobile";
            sendOtpPayload.pinId = pinId;
          }
          const otpSendRes: any = await axiosInstance.post(
            sendOtpUrl,
            sendOtpPayload
          );
          if (otpSendRes?.success) {
            let token = otpSendRes?.data?.token;
            if (isFrom === "property-details-update") {
              // saveContactDetails({
              //   // email: payload?.email,
              //   phone: payload?.mobile,
              // });
              dispatch(
                setUserDetails({
                  ...userDetails,
                  sellerContact: payload?.mobile || "",
                })
              );
              // onSubmit(payload);
            }
            onSubmit(token);
          }
        } else {
          const updatedDetails = {
            ...registrationDetails,
          };
          if (isEmail) {
            // const payload = {
            //   fullName: registrationDetails.fullName,
            //   email: registrationDetails.email?.toLowerCase(),
            //   mobile: registrationDetails.mobile,
            //   nationality: registrationDetails?.nationality,
            //   documentType: registrationDetails?.document
            //     ? registrationDetails?.documentType
            //     : "",
            //   dldNumber: registrationDetails.dldNumber,
            //   isBroker: registrationDetails.broker,
            //   password: encryptData(registrationDetails.password) || "",
            //   dateOfBirth: registrationDetails.dateOfBirth,
            //   emailOtp: otp.join(""),
            //   mobileVerification: {
            //     pinId: pinId,
            //     otp: registrationDetails.mobileOtp,
            //   },
            // };
            const formData = new FormData();

            formData.set(
              "fullName",
              capitalizeWords(registrationDetails.fullName) || ""
            );
            formData.set(
              "email",
              registrationDetails.email?.toLowerCase() || ""
            );
            formData.append("mobile", registrationDetails.mobile || "");
            formData.append(
              "nationality",
              registrationDetails?.nationality || ""
            );
            formData.append(
              "documentType",
              registrationDetails?.document
                ? registrationDetails?.documentType
                : ""
            );
            formData.append("dldNumber", registrationDetails.dldNumber || "");
            formData.append("isBroker", registrationDetails.broker);
            formData.append(
              "password",
              encryptData(registrationDetails.password) || ""
            );
            formData.append(
              "dateOfBirth",
              registrationDetails.dateOfBirth || ""
            );
            formData.append("emailOtp", otp.join("") || "");
            formData.append(
              "mobileVerificationOtp",
              registrationDetails.mobileOtp || ""
            );
            formData.append("mobileVerificationPinId", pinId);
            formData.append("file", registrationDetails.document || "");

            try {
              const token: any = await executeCaptcha();
              if (token) {
                const url = `/${APIURL.AUTH}/${APIURL.REGISTER}`;
                const res: any = await axiosInstance.post(url, formData, {
                  headers: {
                    captchatoken: token,
                  },
                });
                if (res.success && res.data) {
                  const {
                    accessToken = "",
                    refreshToken = "",
                    ...userInfo
                  } = res?.data || {};
                  // for GaEvents
                  pushGaEvents({
                    event_name: "register_submit",
                    user_id: res?.data?.userDetails?.user_id,
                  });
                  setCookie(COOKIE_NAME.token, accessToken);
                  setCookie(COOKIE_NAME.refreshToken, refreshToken);
                  dispatch(setRole(res?.data?.role));
                  dispatch(setUserDetails(userInfo));
                }
              }
            } catch (err: any) {
              console.error("error in register api: ", err);
              if (err?.response?.data?.message === "Invalid OTP for mobile!") {
                onBack("", isResetFlow);
              }
              return;
            }
          } else {
            updatedDetails.mobileOtp = otp.join("");
          }
          dispatch(
            setRegistrationDetails({
              ...updatedDetails,
            })
          );
          const res = setOtp(["", "", "", ""]);
          setError("");
          setTimer(60);
          setCanResend(false);
          onSubmit({
            ...payload,
          });
        }
      } catch (err) {
        setWrongOTP(true);
        setOtp(["", "", "", ""]);
        // setError(
        //   `OTP does not match with the one we sent to your ${
        //     isEmail ? "email" : "mobile number"
        //   }`
        // );
        console.error("error in send otp api: ", err);
      }
      (document.getElementById(`otp-${0}`) as HTMLInputElement).focus();
    } else {
      setError("Please enter a valid 4-digit OTP.");
    }
  };

  const handleResend = async () => {
    if (canResend) {
      const token: any = await executeCaptcha();
      if (token) {
        const sendOtpUrl = `/${APIURL.AUTH}/${APIURL.OTP}/${APIURL.SEND}`;

        const sendOtpPayloadMobile = {
          destination: DESTINATION.MOBILE,
          mobile: payload.mobile || registrationDetails?.mobile,
          instance: payload.instance || OTP_INSTANCE.VERIFICATION,
        };

        const sendOtpPayloadEmail = {
          destination: DESTINATION.EMAIL,
          email: payload.email || registrationDetails?.email,
          instance: payload.instance || OTP_INSTANCE.VERIFICATION,
          fullName: registrationDetails.fullName,
        };

        const identifier = isEmail
          ? sendOtpPayloadEmail.email
          : sendOtpPayloadMobile.mobile;
        setOtp(["", "", "", ""]);

        if (otpAttempts[identifier] >= MAX_OTP_ATTEMPTS) {
          toast.error("Maximum Limit Exceed");
          return;
        }

        if (isEmail) {
          const otpSendResEmail = await axiosInstance.post(
            sendOtpUrl,
            sendOtpPayloadEmail,
            {
              headers: {
                captchatoken: token,
              },
            }
          );
          if (otpSendResEmail.success) {
            setOtpAttempts((prevAttempts) => ({
              ...prevAttempts,
              [identifier]: (prevAttempts[identifier] || 0) + 1,
            }));

            setTimer(60);
            setCanResend(false);
          }
        } else {
          const otpSendResMobile = await axiosInstance.post(
            sendOtpUrl,
            sendOtpPayloadMobile,
            {
              headers: {
                captchatoken: token,
              },
            }
          );
          if (otpSendResMobile.success) {
            setOtpAttempts((prevAttempts) => ({
              ...prevAttempts,
              [identifier]: (prevAttempts[identifier] || 0) + 1,
            }));
            setPinId(otpSendResMobile?.data?.pinId);
            setTimer(60);
            setCanResend(false);
          }
        }
      }
    }
  };

  return (
    <div
      className={`${styles.otpContainer}  login-popup ${styles.containBack}`}
    >
      {!verification && (
        <>
          {!isEmail && (
            <>
              <div className="flex items-center justify-center w-full">
                {!payload?.haveCross && (
                  <button
                    className={`${styles.backButton}`}
                    onClick={() => {
                      onBack("", isResetFlow);
                    }}
                  >
                    <StyledIcon icon={"back"} inline={true} />
                  </button>
                )}
                <div className="modalTopHeading">Verify your phone</div>
                <div
                  className={`absolute right-3 top-1 text-black-500 text-4xl cursor-pointer font-normal `}
                  onClick={onClose}
                >
                  {/* × */}
                  {isFrom === "registerWithNumber" && "×"}
                </div>
              </div>
              <div className="modalSubComment">
                <span>
                  We sent a 4-digit code to&nbsp;
                  <span className="black bold">
                    {payload?.mobile || value || registrationDetails?.mobile}
                  </span>
                </span>
              </div>
            </>
          )}
          {isEmail && (
            <>
              <div className="flex items-center justify-center w-full">
                <button
                  className={`${styles.backButton}`}
                  onClick={() => {
                    onBack("", isResetFlow);
                  }}
                >
                  <StyledIcon icon={"back"} inline={true} />
                </button>
                <div className="modalTopHeading">Verify your email</div>
              </div>
              <div className="modalSubComment">
                <span className="w-full block">
                  Enter the code below to verify &nbsp;
                  <span className="black bold">
                    {payload?.email || value || registrationDetails?.email}
                  </span>
                  &nbsp;
                </span>
                <span>Please check your Inbox/ Spam/ Junk Folder</span>
              </div>
            </>
          )}
        </>
      )}
      {verification && (
        <>
          {!isEmail && (
            <>
              <div className="flex items-center justify-center w-full">
                <button
                  className={`${styles.backButton}`}
                  onClick={() => {
                    onBack(payload.email, isResetFlow);
                  }}
                >
                  <StyledIcon icon={"back"} inline={true} />
                </button>

                <div className="modalTopHeading">OTP Verification</div>
              </div>
              <div className="modalSubComment">
                <span>
                  Enter the verification code we just sent on your
                  <span className="black bold">
                    <span> mobile number&nbsp; &nbsp;</span>
                    {payload?.mobile || value || registrationDetails?.mobile}
                  </span>
                </span>
              </div>
            </>
          )}
          {isEmail && (
            <>
              <div className="flex items-center justify-center w-full">
                <button
                  className={`${styles.backButton}`}
                  onClick={() => {
                    onBack(payload.email, isResetFlow);
                  }}
                >
                  <StyledIcon icon={"back"} inline={true} />
                </button>

                <div className="modalTopHeading">OTP Verification</div>
              </div>
              <div className="modalSubComment">
                <span className="w-full block">
                  Enter the verification code we just sent on your
                  <span> email address&nbsp; &nbsp;</span>
                  <span className="black bold">
                    {payload?.email || value || registrationDetails?.email}
                  </span>
                  &nbsp;
                </span>
              </div>
            </>
          )}
        </>
      )}
      <form onSubmit={handleSubmit} className={styles.margin}>
        <div className={styles.otpInputs}>
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              type="tel"
              maxLength={1}
              value={digit}
              inputMode="numeric"
              autoFocus={index === 0}
              onChange={(e) => handleChange(e, index)}
              className={`${styles.otpInput}  ${
                wrongOTP ? styles.wrongOTP : digit ? styles.haveInput : ""
              }`}
            />
          ))}
        </div>
        {error && <p className={styles.error}>{error}</p>}
        <button type="submit" className="login-button">
          Verify&nbsp;{isEmail ? "Email" : "Phone"}
        </button>
      </form>
      {isEmail && (
        <div className="modalSubComment">
          Didn't receive Email?
          <span
            className={`${styles.resendLink} bold ${
              !canResend ? styles.disabledLink : ""
            }`}
            onClick={handleResend}
            style={{ cursor: canResend ? "pointer" : "not-allowed" }}
          >
            {canResend ? "Resend" : `Resend in ${timer}s`}
          </span>
        </div>
      )}
      {!isEmail && (
        <div className="modalSubComment">
          Didn't receive SMS?
          <span
            className={`${styles.resendLink} bold ${
              !canResend ? styles.disabledLink : ""
            }`}
            onClick={handleResend}
            style={{ cursor: canResend ? "pointer" : "not-allowed" }}
          >
            {canResend ? "Resend" : `Resend in ${timer}s`}
          </span>
        </div>
      )}
    </div>
  );
};

export default GetOTPComponent;
